import React from "react"
import { useSelector } from "react-redux"

import OfflineOrderTableRow from "./OfflineOrderTableRow"
import OfflineOrderSyncButton from "./OfflineOrderSyncButton"
import OfflineOrderTableHeader from "./OfflineOrderTableHeader"
import { OrdersEmptyList } from "components"
import classes from "./index.module.scss"

const OfflineOrders = () => {
  const offlineOrders =
    useSelector(state => state.offlineOrders)

  const noOrders = offlineOrders.length === 0

  return (
    <div className={classes["container"]}>
      <div className={classes["table-container"]}>
        <table className={classes["table"]}>
          <OfflineOrderTableHeader />
          {!noOrders
            ?
            <tbody>
              {offlineOrders.map(offlineOrder =>
                <OfflineOrderTableRow
                  key={offlineOrder.offlineOrderId}
                  offlineOrder={offlineOrder}
                />
              )}
            </tbody>
            :
            <OrdersEmptyList />
          }
        </table>
      </div>
      <OfflineOrderSyncButton />
    </div>
  )
}

export default OfflineOrders